<template>
	<div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
		style="overflow: hidden;">
		<div class="m-portlet m-portlet--mobile">
			<div class="m-portlet__body" style="padding: .2rem 2.2rem;">
				<!--begin: Search Form -->
				<div class="m-form m-form--label-align-right">

				</div>
				<div style="clear: both;"></div>
				<div class="m--margin-top-10 m--margin-bottom-10"
					style="width: 100%;text-align: center;float: initial;">
				</div>
				<!--end: Search Form -->
				<div class="m-portlet__body" style="padding: .2rem 2.2rem;">
					<!--begin: Datatable -->
					<el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
						<el-table-column prop="stuName" label="姓名" width="120">
						</el-table-column>
						<el-table-column prop="stuNo" label="工号" width="120">
						</el-table-column>
						<el-table-column prop="cpSecName" label="科室" width="200">
						</el-table-column>
						<el-table-column prop="delayMonth" label="延期月份" width="200">
						</el-table-column>
						<el-table-column prop="reason" label="延期原因">
						</el-table-column>
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="Audit(scope.row)" type="text" size="medium">审核
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!--end: Datatable -->
					<div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="condition.currentPage" :page-sizes="[2, 10, 20, 30, 40]"
							:page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
							:total="condition.recordCount">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>

		<el-dialog title="审核" :visible.sync="ShowCheckInfo" width="300px">
			<div style="width: 100%; text-align: center;">
				<el-button plain @click="MultipleCheck(2)">不通过</el-button>
				<el-button type="primary" plain @click="MultipleCheck(1)">通过</el-button>
			</div>

		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'DelayEvaluationAuditList',
		data() {
			return {
				condition: {
					token: '',
					dataStatus: 0,
					currentPage: 1,
					pageSize: 10
				},
				tableData: null,
				searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/DelayEvaluationList',
				loading: true,
				ShowCheckInfo: false,
				currentRow:{}
			}
		},
		methods: {
			// 调整每页显示数
			handleCurrentChange: function(val) {
				this.condition.firstSearch = false
				this.condition.currentPage = val
				this.$refs.btnSearch.Search()
			},
			// 分页操作
			handleSizeChange: function(val) {
				this.condition.firstSearch = false
				this.condition.pageSize = val
				this.condition.currentPage = 1
				this.$refs.btnSearch.Search()
			},
			//加载延期列表
			loadDelayList: function() {
				var loaddata = {
					token: sessionStorage.getItem('token')
				}
				this.$http.post(this.searchUrl, this.condition)
					.then(res => {
						if (res.data.Code === 0) {
							this.tableData = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.tableData = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			Audit: function(row) {
				this.currentRow = row
				this.ShowCheckInfo = true
			},
			MultipleCheck: function(result) {
				var that = this
				var rdata = {
					token: sessionStorage.getItem('token'),
					dataStatus:result,
					id:that.currentRow.id
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/CheckDelay', rdata)
					.then(res => {
						if (res.data.Code === 0) {
							that.$message({
								message: '审核成功',
								type: 'success'
							})
							that.loadDelayList()
						} else {
							that.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						that.ShowCheckInfo = false
					})
			}

		},
		mounted: function() {
			this.condition.token = sessionStorage.getItem('token')
			this.loadDelayList()
		}
	}
</script>

<style scoped="scoped">
	.message-box {
		width: 600px;
	}

	/deep/.el-table .cell {
		line-height: 25px;
	}
</style>
